import React from 'react';
import List from '../../models/home/List';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AuthService from "../../services/auth.service";

export default function ListHome() {

    const { t } = useTranslation();

    return (
        <div>
            <br />
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                </ol>
            </nav>
            <br/>
            { AuthService.isLogged() ?

                <List />

                :

                <b>{t("Global_MustDoLogin_Message")}</b>
            }
            <br />
            <br />
        </div >
    );
}
